import { useCallback, useEffect, useState } from 'react';
import { getTopOnScrollView } from '$utils';

export function useVisibleElement(elem, center = false, threshold = 200) {
  const [visible, setVisible] = useState(false);

  const handleScroll = useCallback(() => {
    if (!elem.current) {
      return;
    }

    const scrollEl = elem.current.closest('._ScrollView') as HTMLDivElement;
    if (!scrollEl) {
      return;
    }

    const st = scrollEl.scrollTop;
    const top = getTopOnScrollView(elem.current);
    const th = threshold;

    const isVisible = center
      ? st + scrollEl.offsetHeight / 2 > top &&
        st + scrollEl.offsetHeight / 2 < top + elem.current.offsetHeight
      : st + scrollEl.offsetHeight - th > top &&
        st < top + elem.current.offsetHeight - th;

    if (isVisible !== visible) {
      setVisible(isVisible);
    }
  }, [elem.current, visible, setVisible]);

  useEffect(() => {
    if (!elem.current) {
      return;
    }

    const scrollEl = elem.current.closest('._ScrollView');
    if (!scrollEl) {
      return;
    }

    scrollEl.addEventListener('scroll', handleScroll, true);
    const timer = setTimeout(handleScroll, 200);

    return () => {
      clearTimeout(timer);
      scrollEl.removeEventListener('scroll', handleScroll, true);
    };
  }, [elem.current, handleScroll]);

  return {
    visible,
  };
}
